import { useEffect, useState, useMemo } from 'react';
import { cls } from 'reactutils';
import { AccountPeriodEnum, BillingPeriodEnum } from 'libs/enums';
import PayQuestionIcon from '@/biz-components/web/AgreementModal/PayQuestionIcon';
const TradeMode = ({ selectTradeAgreement, onSelect }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const renderSupplierSettingList = useMemo(
    () =>
      selectTradeAgreement.discountByMethodList?.map((item) => {
        item.sysNo =
          item.accountPeriod + '-' + (item.billingPeriod == null ? '' : item.billingPeriod);
        return item;
      }) || [],
    [selectTradeAgreement.discountByMethodList],
  );
  const handleSelectPeriod = (data, index) => {
    // $mall.setCustomPeriodSysNoBySupplier(data.sysNo, this.supplierSysNo)
    setActiveIndex(index);
    onSelect(data);
  };
  const formatEnums = (enums, data) => {
    const res = Object.values(enums).find((v) => v.value === data);
    return res ? res.label : '';
  };
  const handleQuestionIcon = function (period) {
    var msg = 1;
    if (period.billingPeriod == null && period.accountPeriod === 1) {
      msg = 2;
    } else if (period.billingPeriod == null && period.accountPeriod === 2) {
      msg = 3;
    } else if (period.billingPeriod == null && period.accountPeriod === 3) {
      msg = 7;
    } else {
      msg = 1;
    }
    return msg;
  };
  const initActiveIndex = function (newValue) {
    if (!newValue) return;
    var i = newValue.findIndex((item) => item.active);
    if (i < 0) return;
    setActiveIndex(i);
  };
  useEffect(() => {
    initActiveIndex(renderSupplierSettingList);
  }, [renderSupplierSettingList]);
  return (
    <>
      <div className="clearfix account-period">
        <div className="pd-l account-label">交易方式</div>
        <div className="pd-r pd-one-info account-period-wrap">
          {renderSupplierSettingList.map((item, index) => (
            <div
              key={index}
              className={cls(
                'product-filter-item account-period-item',
                activeIndex === index && 'active',
              )}
              onClick={() => {
                handleSelectPeriod(item, index);
              }}
            >
              <span className="period-name">
                {item.accountPeriod === AccountPeriodEnum.CUSTOM.value ? (
                  <span>
                    {item.billingPeriod === BillingPeriodEnum.OTHER.value &&
                    !!selectTradeAgreement.billingPeriodOtherDays
                      ? `结算付款（${selectTradeAgreement.billingPeriodOtherDays}天后一次性付款）`
                      : formatEnums(BillingPeriodEnum, item.billingPeriod)}
                  </span>
                ) : (
                  <span>{formatEnums(AccountPeriodEnum, item.accountPeriod)}</span>
                )}
                <span className="period-tip">
                  <PayQuestionIcon type={handleQuestionIcon(item)} />
                </span>
              </span>
              <div className="active-icon" />
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
        .account-period {
          margin-top: 10px;
        }
        .pd-l {
          width: 50px;
          margin-right: 40px;
          color: #999;
          margin-left: 20px;
          height: 28px;
          line-height: 28px;
          display: inline-block;
          font-size: 12px;
        }
        .pd-one-info {
          position: relative;
          bottom: -4px;
          display: inline-block;
          font-size: 12px;
          width: 600px;
        }
        .product-filter-item {
          display: inline-block;
          padding: 9px 13px 7px 14px;
          font-size: 12px;
          line-height: 12px;
          border: 1px solid #e8e8e8;
          margin-bottom: 10px;
          margin-right: 10px;
          cursor: pointer;
          background-color: #fff;
          border-color: #fff;
          color: #666;
          position: relative;
          width: auto;
          min-width: 84px;
          padding-left: 17px;
          padding-right: 17px;
          text-align: center;
        }
        .product-filter-item.active {
          border-color: var(--rv-primary-color);
        }
        .product-filter-item.active .active-icon {
          display: block;
          position: absolute;
          right: -8px;
          bottom: -8px;
          border: 8px solid transparent;
          border-top: 8px solid var(--rv-primary-color);
          transform: rotate(-45deg);
        }
        .period-name {
          position: relative;
        }
        .product-filter-item.active .active-icon:after {
          content: "";
          position: absolute;
          left: -2px;
          top: -7px;
          width: 6px;
          height: 3px;
          border-color: transparent transparent #fff #fff;
          border-style: solid;
          border-width: 1px;
        }
        :global(.period-tip .iconfont) {
          font-size: 12px;
        }
        .period-tip {
          opacity: 0;
          position: absolute;
          right: -14px;
          top: 0;
          height: 14px;
          line-height: 14px;
        }
        .account-period-item:hover .period-tip {
          opacity: 1;
        }
      `}</style>
    </>
  );
};
export default TradeMode;
